import checkCanTranslate from '../utils/checkCanTranslate';
import getOgmaSupportedLanguageTag from '../utils/getOgmaSupportedLanguageTag';
import store from '../store/store';
import SupportedLanguage from '../store/schema/SupportedLanguage';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setSupportedLanguageMap', function setSupportedLanguageMap(
    userCulture: string,
    supportedLanguageMap: Map<string, SupportedLanguage>
) {
    const userLocaleInOgma = getOgmaSupportedLanguageTag(userCulture);
    const userLanguage = supportedLanguageMap.get(userLocaleInOgma);

    if (userLanguage) {
        store.localeOfSupportedLanguageMap = userCulture;
        store.userLanguageName = userLanguage.LanguageName;
        store.userLanguageTag = userLocaleInOgma;
        store.supportedLanguageMap = supportedLanguageMap;
        store.isUserLocaleSupported = checkCanTranslate(userCulture);
    } else {
        store.isUserLocaleSupported = false;
    }
});
